webpackJsonp([5],{

/***/ "/6Js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeedBacksList = (function () {
    FeedBacksList.$inject = ["OurFeedbackSvc"];
    function FeedBacksList(OurFeedbackSvc) {
        this.OurFeedbackSvc = OurFeedbackSvc;
        this.feedbacks = this.OurFeedbackSvc.getForPage();
    }
    return FeedBacksList;
}());
angular.module('animatronApp.feedback').component('feedbacksList', {
    controller: FeedBacksList,
    templateUrl: __webpack_require__("JBV/")
});


/***/ }),

/***/ "ApdG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/feedback-swipable_74da50d81867226c4dd2adcf6081ada4.html";

/***/ }),

/***/ "HaCt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RandomFeedBack = (function () {
    RandomFeedBack.$inject = ["OurFeedbackSvc", "$scope", "$timeout"];
    function RandomFeedBack(OurFeedbackSvc, $scope, $timeout) {
        var _this = this;
        this.OurFeedbackSvc = OurFeedbackSvc;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.loopTime = 0;
        this.step = 0;
        this.feedbacks = this.OurFeedbackSvc.getForPage();
        this.changeLoop();
        $scope.$on('$destroy', function () { return $timeout.cancel(_this.timeoutLiner); });
    }
    RandomFeedBack.prototype.changeLoop = function () {
        var _this = this;
        this.timeoutLiner = this.$timeout(function () {
            _this.currentFB = _this.feedbacks[_this.step++];
            _this.loopTime = _this.currentFB.twit.length * 50;
            _this.$timeout.cancel(_this.timeoutLiner);
            if (_this.step >= _this.feedbacks.length) {
                _this.step = 0;
            }
            _this.changeLoop();
        }, this.loopTime);
    };
    return RandomFeedBack;
}());
angular.module('animatronApp.feedback').component('randomFeedback', {
    controller: RandomFeedBack,
    controllerAs: 'randomFeedback',
    templateUrl: __webpack_require__("TNnD")
});


/***/ }),

/***/ "JBV/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/feedbacks-list_e4eb2203fe00ed402adea96b363236eb.html";

/***/ }),

/***/ "JKrW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lazy_modules_1 = __webpack_require__("bUzP");
var FeedbackSlider = (function () {
    FeedbackSlider.$inject = ["$element", "$q", "OurFeedbackSvc"];
    function FeedbackSlider($element, $q, OurFeedbackSvc) {
        this.$element = $element;
        this.$q = $q;
        this.OurFeedbackSvc = OurFeedbackSvc;
        this.feedbacks = this.feedbackIds ? this.OurFeedbackSvc.getByIds(this.feedbackIds) : this.OurFeedbackSvc.getFor(this.product);
        this.flicktyPromise = $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); });
    }
    FeedbackSlider.prototype.$postLink = function () {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            new Flickity(_this.$element[0].firstChild, {
                cellSelector: 'feedback-slider .feedback-item',
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
        });
    };
    FeedbackSlider.prototype.getImageUrl = function (image) {
        return "https://assets.animatron.com/images/landing/feedbacks/" + image;
    };
    return FeedbackSlider;
}());
exports.FeedbackSlider = FeedbackSlider;
angular.module('animatronApp.feedback').component('feedbackSlider', {
    bindings: {
        theme: '@?',
        product: '<?',
        feedbackIds: '<?'
    },
    controller: FeedbackSlider,
    templateUrl: __webpack_require__("Zm8k")
});


/***/ }),

/***/ "TNnD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/random-feedback_3cd57d5b19b12f69c35e92ef71781ca5.html";

/***/ }),

/***/ "Zm8k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/feedback-slider_dfe3bd5bd8b376c1575256d5579b55ea.html";

/***/ }),

/***/ "euAE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var lazy_modules_1 = __webpack_require__("bUzP");
var FeedbackSwipable = (function () {
    /* @ngInject */
    FeedbackSwipable.$inject = ["$element", "$q", "TranslateSvc", "OurFeedbackSvc"];
    function FeedbackSwipable($element, $q, TranslateSvc, OurFeedbackSvc) {
        this.$element = $element;
        this.$q = $q;
        this.TranslateSvc = TranslateSvc;
        this.OurFeedbackSvc = OurFeedbackSvc;
        this.flicktyPromise = options.handHeld ?
            $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); }) :
            $q.reject(null);
    }
    FeedbackSwipable.prototype.$postLink = function () {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            new Flickity(_this.$element[0].firstChild, {
                cellSelector: '.feedback',
                prevNextButtons: false,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false
            });
        });
    };
    return FeedbackSwipable;
}());
var FeedbackSwipableByKind = (function (_super) {
    tslib_1.__extends(FeedbackSwipableByKind, _super);
    function FeedbackSwipableByKind() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.feedbacks = _.range(1, 4).map(function (i) { return _.mapObject({
            twit: "landing." + _this.kind + ".feedback" + i,
            name: "landing." + _this.kind + ".feedback" + i + ".author",
            company: "landing." + _this.kind + ".feedback" + i + ".author.position"
        }, function (v) { return _this.TranslateSvc.get(v); }); });
        return _this;
    }
    return FeedbackSwipableByKind;
}(FeedbackSwipable));
var FeedbackSwipableByPage = (function (_super) {
    FeedbackSwipableByPage.$inject = ["$element", "$q", "TranslateSvc", "OurFeedbackSvc"];
    tslib_1.__extends(FeedbackSwipableByPage, _super);
    function FeedbackSwipableByPage($element, $q, TranslateSvc, OurFeedbackSvc) {
        var _this = _super.call(this, $element, $q, TranslateSvc, OurFeedbackSvc) || this;
        _this.$element = $element;
        _this.$q = $q;
        _this.TranslateSvc = TranslateSvc;
        _this.OurFeedbackSvc = OurFeedbackSvc;
        return _this;
    }
    FeedbackSwipableByPage.prototype.$onInit = function () {
        var allFeedbacks = this.OurFeedbackSvc
            .getForPage()
            .filter(function (f) { return f.twit.length < FeedbackSwipableByPage.MaxTwitSize; });
        this.feedbacks = this.count ? _.first(allFeedbacks, this.count) : allFeedbacks;
    };
    return FeedbackSwipableByPage;
}(FeedbackSwipable));
FeedbackSwipableByPage.MaxTwitSize = 230;
angular.module('animatronApp.feedback').component('feedbackSwipableByKind', {
    bindings: {
        kind: '@'
    },
    controller: FeedbackSwipableByKind,
    templateUrl: __webpack_require__("ApdG")
});
angular.module('animatronApp.feedback').component('feedbackSwipableByPage', {
    bindings: {
        count: '<'
    },
    controller: FeedbackSwipableByPage,
    templateUrl: __webpack_require__("ApdG")
});


/***/ }),

/***/ "tsWW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OurFeedbackSvc = (function () {
    OurFeedbackSvc.$inject = ["$state", "TranslateSvc"];
    function OurFeedbackSvc($state, TranslateSvc) {
        this.$state = $state;
        this.TranslateSvc = TranslateSvc;
        this.feedbacks = (_.range(1, 6).map(function (n) { return ({
            product: 'STUDIO',
            pages: ['studio-pricing'],
            name: "pricing.feedback" + n + ".author",
            company: "pricing.feedback" + n + ".author.position",
            twit: "pricing.feedback" + n
        }); })).concat([
            {
                product: 'STUDIO',
                pages: ['studio-landing-banner', 'studio-landing-explainer'],
                name: 'landing.startup.feedback2.author',
                company: 'landing.startup.feedback2.author.position',
                twit: 'landing.startup.feedback2'
            },
            {
                product: 'STUDIO',
                pages: ['studio-landing-banner', 'studio-landing-explainer'],
                name: 'landing.startup.feedback3.author',
                company: 'landing.startup.feedback3.author.position',
                twit: 'landing.startup.feedback3'
            },
            {
                product: 'STUDIO',
                pages: ['studio-landing-banner'],
                name: 'landing.everyone.feedback4.author',
                company: 'landing.everyone.feedback4.author.position',
                twit: 'landing.everyone.feedback4'
            },
            {
                product: 'STUDIO',
                pages: ['studio-landing-banner'],
                name: 'landing.everyone.feedback5.author',
                company: 'landing.everyone.feedback5.author.position',
                twit: 'landing.everyone.feedback5'
            },
            {
                product: 'STUDIO',
                pages: ['studio-landing-banner'],
                name: 'landing.everyone.feedback6.author',
                company: 'landing.everyone.feedback6.author.position',
                twit: 'landing.everyone.feedback6'
            },
            {
                product: 'STUDIO',
                pages: ['studio-landing-explainer'],
                name: 'landing.startup.feedback1.author',
                company: 'landing.startup.feedback1.author.position',
                twit: 'landing.startup.feedback1'
            },
            {
                id: 'smith1',
                product: 'WAVE',
                avatar: 'mari-smith.png',
                name: 'wave.feedback-slider.author-name-1',
                company: 'wave.feedback-slider.author-description-1',
                twit: 'wave.feedback-slider.content-1',
                link: '/videos-for-social-media-mari-smith',
                tutorial: 'wave.feedback-slider.mari-smith.tutorial'
            },
            {
                id: 'daniel1',
                avatar: 'daniel.jpg',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-2',
                company: 'wave.feedback-slider.author-description-2',
                twit: 'wave.feedback-slider.content-2'
            },
            {
                id: 'aandpete1',
                avatar: 'aandp.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-3',
                company: 'wave.feedback-slider.author-description-3',
                twit: 'wave.feedback-slider.content-3'
            },
            {
                id: 'guy_kawasaki',
                avatar: 'guy_kawasaki.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-4',
                company: 'wave.feedback-slider.author-description-4',
                twit: 'wave.feedback-slider.content-4'
            },
            {
                id: 'andy_crestodina',
                avatar: 'andy_crestodina.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-5',
                company: 'wave.feedback-slider.author-description-5',
                twit: 'wave.feedback-slider.content-5'
            },
            {
                id: 'jeff_sieh',
                avatar: 'jeff_sieh.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-6',
                company: 'wave.feedback-slider.author-description-6',
                twit: 'wave.feedback-slider.content-6'
            },
            {
                id: 'amy-schmittauer_landino',
                avatar: 'amy_schmittauer_landino.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-7',
                company: 'wave.feedback-slider.author-description-7',
                twit: 'wave.feedback-slider.content-7'
            },
            {
                id: 'lilach_bullock',
                avatar: 'Lilach-Bullock.jpg',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-8',
                company: 'wave.feedback-slider.author-description-8',
                twit: 'wave.feedback-slider.content-8'
            },
            {
                id: 'donna_moritz',
                avatar: 'donna_moritz.png',
                product: 'WAVE',
                name: 'wave.feedback-slider.author-name-9',
                company: 'wave.feedback-slider.author-description-9',
                twit: 'wave.feedback-slider.content-9'
            },
            {
                product: 'ANY',
                name: 'landing.everyone.feedback7.author',
                company: 'landing.everyone.feedback7.author.position',
                twit: 'landing.everyone.feedback7'
            },
            {
                product: 'ANY',
                avatar: 'ean.png',
                name: 'pricing.feedback4.author',
                company: 'pricing.feedback4.author.position',
                twit: 'pricing.feedback4'
            },
            {
                product: 'ANY',
                name: 'landing.everyone.feedback2.author',
                company: 'landing.everyone.feedback2.author.position',
                twit: 'landing.everyone.feedback2'
            },
            {
                product: 'ANY',
                name: 'pricing.feedback1.author',
                avatar: 'ixe.png',
                company: 'pricing.feedback1.author.position',
                twit: 'pricing.feedback1'
            }
        ]);
    }
    OurFeedbackSvc.prototype.getByIds = function (feedbackIds) {
        var list = this.feedbacks.filter(function (fb) { return fb.id && feedbackIds.includes(fb.id); });
        return this.map(list);
    };
    OurFeedbackSvc.prototype.getFor = function (product) {
        var list = this.feedbacks.filter(function (fb) { return fb.product && fb.product === product; });
        return this.map(list);
    };
    OurFeedbackSvc.prototype.getForPage = function () {
        var _this = this;
        var list = this.feedbacks.filter(function (fb) { return fb.pages && fb.pages.includes(_this.$state.current.name); });
        return this.map(list);
    };
    OurFeedbackSvc.prototype.map = function (list) {
        var _this = this;
        var noTranslationProp = ['product', 'avatar', 'id', 'link'];
        return list.map(function (fb) {
            return _.mapObject(fb, function (value, key) {
                return _.isString(value) && !noTranslationProp.includes(key) ? _this.TranslateSvc.get(value) : value;
            });
        });
    };
    return OurFeedbackSvc;
}());
exports.OurFeedbackSvc = OurFeedbackSvc;
angular.module('animatronApp.feedback').service('OurFeedbackSvc', OurFeedbackSvc);


/***/ })

});


// WEBPACK FOOTER //
// javascripts/5-257c10c0995a4d25fa59.min.js